import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment';

export default class extends PureComponent {
  static propTypes = {
    // eslint-disable-next-line
    ...TextField.propTypes,
    prefix: PropTypes.string,
    suffix: PropTypes.string,
  }

  get key() {
    //forces remounting to fix bug when adding/removing adornments
    const {prefix, suffix} = this.props
    return (prefix ? 1 : 0) + (suffix ? 2 : 0)
  }

  get prefix() {
    const {prefix} = this.props
    return prefix ? <InputAdornment position="start">{prefix}</InputAdornment> : undefined
  }

  get suffix() {
    const {suffix} = this.props
    return suffix ? <InputAdornment position="end">{suffix}</InputAdornment> : undefined
  }

  get inputProps() {
    return {...this.props.inputProps, startAdornment: this.prefix, endAdornment: this.suffix}
  }

  render = () =>
    <TextField key={this.key} {...this.props} InputProps={this.inputProps}/>

}